export default __webpack_public_path__ + "static/media/Icons_User_Grey Icon.b9c97183.svg";